/*jshint esversion: 8 */
import React, { Component } from "react";

import PropTypes from "prop-types";
import { observer } from "mobx-react";
import { withStyles } from "@material-ui/core/styles";
import TextField from "@material-ui/core/TextField";
import FormControl from "@material-ui/core/FormControl";
import InputLabel from "@material-ui/core/InputLabel";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import Button from "@material-ui/core/Button";
import { toJS } from "mobx";

// add dialog
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";

import store from "../../../components/stores/Store";
import { getDevelopers } from "../../../db/DeveloperRequestHandler";
import {
  addRoom,
  getRooms,
  deleteSelectedRoom,
  publishSelectedRoom,
  recallSelectedRoom,
  addRoomsFromExcel,
} from "../../../db/RoomRequestHandler";

import { getIfFuncAuthorized } from "../../../utils/CheckSomething";

import { exportExcel } from "../../../utils/ExcelHandler";
import CheckHandler from "../../../utils/CheckHandler";
import ITextField from "../../../components/UI/ITextField";

const styles = {
  root: {},
  textField: {
    width: "15ch",
  },
  formControl: {
    margin: "10px",
    width: "20ch",
    minWidth: "20ch",
  },
  rootform: {
    textAlign: "left",
    marginTop: "10px",
  },
  button: {
    marginLeft: "10px",
    marginTop: "10px",
  },
  input: {
    display: "none",
  },
};

class SelectionOfRoomManagementInner extends Component {
  constructor() {
    super();
    store.clearTableConfig();
    store.setSelections({
      // 定制
      propertyName: "", // 楼盘名称
      fuzzyWord: "",
      state: "", // 状态：‘1’-未发布，‘2’-已发布，‘3’-销售中，‘4’-已销售。
    });
    this.state = {
      // 定制
      addRoomDialogOpen: false,
      addRoomParams: {
        developer: "",
        buildingName: "",
        buildingNo: "",
        buildingNo2: "",
        floor: "",
        roomNo: "",
        layout: "",
        space: "",
        pricePerM2: "", // 备案单价(元/平方米)
        priceTot: "", // 备案总价
        minPriceTot: "", // 最高限价单价
        totalPrice2: "", // 最高限价总价
        remarks: "",
      },
    };
    // 定制
    this.search = this.search.bind(this);
    this.getDevelopers = this.getDevelopers.bind(this);
    this.addRoom = this.addRoom.bind(this);
    this.onRoomDialogChange = this.onRoomDialogChange.bind(this);
    this.publishSelectedRoom = this.publishSelectedRoom.bind(this);
    this.recallSelectedRoom = this.recallSelectedRoom.bind(this);
    this.deleteSelected = this.deleteSelected.bind(this);
    this.clearSelection = this.clearSelection.bind(this);

    this.importExcel = this.importExcel.bind(this);
    this.exportTemplateExcel = this.exportTemplateExcel.bind(this);
    this.exportExcel = this.exportExcel.bind(this);
    this.doImportExcel = this.doImportExcel.bind(this);
  }

  componentDidMount() {
    store.search = this.search;
    this.getDevelopers(); // 定制
    this.search();
    store.clearLinesSelected();
  }
  componentWillUnmount() { }

  async getDevelopers() {
    console.log(`----- send req of getDevelopers`);
    const rst = await getDevelopers({});
    console.log(`----- rst of getDevelopers: `, rst);
    if (rst.code === "error") {
      store.openMessageDialogOpen(rst.msg || "房产商查询错误");
      return true;
    } else if (rst.code === "success") {
      console.log(`----- search rst: `, rst);
      store.setDeveloperTable(rst.data);
      return true;
    }
  }

  onRoomDialogChange(e, prop) {
    // 定制
    e.stopPropagation();
    const newAddRoomParams = this.state.addRoomParams;
    newAddRoomParams[prop] = e.target.value;
    this.setState({ addRoomParams: newAddRoomParams });
  }

  async addRoom() {
    const developer = this.state.addRoomParams.developer.trim();
    const buildingName = this.state.addRoomParams.buildingName.trim();
    const buildingNo = this.state.addRoomParams.buildingNo.trim();
    const buildingNo2 = this.state.addRoomParams.buildingNo2.trim();
    const floor = this.state.addRoomParams.floor.trim();
    const roomNo = this.state.addRoomParams.roomNo.trim();
    const layout = this.state.addRoomParams.layout.trim();
    const space = this.state.addRoomParams.space.trim();
    const pricePerM2 = this.state.addRoomParams.pricePerM2.trim();   // 备案单价(元/平方米)
    const priceTot = this.state.addRoomParams.priceTot.trim();     // 备案总价
    const minPriceTot = this.state.addRoomParams.minPriceTot.trim();  // 最高限价单价
    const totalPrice2 = this.state.addRoomParams.totalPrice2.trim();  // 最高限价总价
    const remarks = (this.state.addRoomParams.remarks || '').trim();
    let developerName = "";
    const developerTable = toJS(store.developerTable);

    for (let index = 0; index < developerTable.length; index++) {
      const element = developerTable[index];
      if (developer === element.ID) {
        developerName = element.name;
        break;
      }
    }

    const chkRst = CheckHandler.checkParams([
      { key: '房产商', value: developer, notNull: true, type: '', maxLength: 64 },
      { key: '房产商名称', value: developerName, notNull: true, type: '', maxLength: 64 },
      { key: '楼盘名称', value: buildingName, notNull: true, type: '', maxLength: 10 },
      { key: '幢号', value: buildingNo, notNull: true, type: '', maxLength: 10 },
      { key: '单元', value: buildingNo2, notNull: true, type: '', maxLength: 10 },
      { key: '楼层', value: floor, notNull: true, type: '', maxLength: 10 },
      { key: '房号', value: roomNo, notNull: true, type: '', maxLength: 10 },
      { key: '户型', value: layout, notNull: true, type: '', maxLength: 10 },
      { key: '建筑面积', value: space, notNull: true, type: 'number', maxLength: 10 },
      { key: '备案单价', value: pricePerM2, notNull: true, type: 'number', maxLength: 10 },
      { key: '备案总价', value: priceTot, notNull: true, type: 'number', maxLength: 16 },
      { key: '最高限价单价', value: minPriceTot, notNull: true, type: 'number', maxLength: 10 },
      { key: '最高限价总价', value: totalPrice2, notNull: true, type: 'number', maxLength: 16 },
      { key: '备注', value: remarks, notNull: false, type: '', maxLength: 20 },
    ]);
    if (chkRst.msg) {
      store.openMessageDialogOpen(chkRst.msg);
      return;
    }

    const rst = await addRoom({
      developer, developerName, buildingName, buildingNo, buildingNo2,
      floor, roomNo, layout, space, pricePerM2, priceTot, minPriceTot,
      totalPrice2, remarks
    });
    if (rst.code === "error") {
      store.openMessageDialogOpen(rst.msg || "系统错误");
      return true;
    } else if (rst.code === "success") {
      console.log(`----- rst: `, rst);
      store.openMessageDialogOpen(rst.msg || "添加成功");
      this.setState({ addRoomDialogOpen: false, addRoomParams: {} });
      this.search();
      store.clearLinesSelected();
      return true;
    }
  }

  async search() {
    if (!getIfFuncAuthorized('房票管理-开发商房源管理-查找')) {
      store.openMessageDialogOpen('权限不足');
      return;
    }
    // 定制
    store.clearLinesSelected();
    const selections = {
      propertyName: ["like", store.selections.propertyName],
      state: ["equal", store.selections.state],
      developerId: ["equal", store.selections.developerId],
    };

    // 模糊搜索
    const fuzzyWord = store.selections.fuzzyWord;
    if (fuzzyWord.trim().length > 1) {
      selections.fuzzyWord = ["equal", fuzzyWord];
    } else if (fuzzyWord.trim().length === 1) {
      store.openMessageDialogOpen("模糊搜索长度至少需为2");
      return true;
    }
    console.log("----- 搜索：", selections);
    const rst = await getRooms({
      where: selections,
      order: store.tableConfig.order || 'desc',
      orderBy: store.tableConfig.orderBy || 'createdate',
      currentPage: store.tableConfig.currentPage, // 当前页
      rowsPerPage: store.tableConfig.rowsPerPage, // 每页条数
    });

    if (rst.code === "error") {
      store.openMessageDialogOpen( rst.msg || "查询错误" );
      return true;
    } else if (rst.code === "success") {
      console.log(`----- search rst: `, rst);
      const table = rst.data;
      for (let index = 0; index < table.length; index++) {
        table[index].locationInfo = `${table[index].buildingNo}-${table[index].unit}-${table[index].floor}-${table[index].roomNumber}`;
      }
      store.setTable(table);
      store.setTableCount(rst.count || 0);
      return true;
    }
  }

  async publishSelectedRoom() {
    if (store.linesSelected.length === 0) {
      store.openMessageDialogOpen("未选择，请选择");
      return;
    }
    const rst = await publishSelectedRoom({ selected: store.linesSelected });
    if (rst.code === "error") {
      store.openMessageDialogOpen( rst.msg || "发布错误" );
      return true;
    } else if (rst.code === "success") {
      store.openMessageDialogOpen( rst.msg || "发布成功" );
      this.search();
      store.clearLinesSelected();
      return true;
    }
  }

  async recallSelectedRoom() {
    if (store.linesSelected.length === 0) {
      store.openMessageDialogOpen( "未选择，请选择" );
      return;
    }

    const rst = await recallSelectedRoom({ selected: store.linesSelected });
    //  console.log(`----- recallSelectedRoom rst: `, rst);
    if (rst.code === "error") {
      store.openMessageDialogOpen( rst.msg || "撤回错误" );
      return true;
    } else if (rst.code === "success") {
      store.openMessageDialogOpen( rst.msg || "撤回成功" );
      this.search();
      store.clearLinesSelected();
      return true;
    }
  }

  async deleteSelected() {
    if (store.linesSelected.length === 0) {
      store.openMessageDialogOpen( "未选择，请选择" );
      return;
    }
    const rst = await deleteSelectedRoom({ selected: store.linesSelected });
    if (rst.code === "error") {
      store.openMessageDialogOpen( rst.msg || "删除错误" );
      return true;
    } else if (rst.code === "success") {
      store.openMessageDialogOpen( rst.msg || "删除成功" );
      this.search();
      store.clearLinesSelected();
      return true;
    }
  }

  clearSelection() {
    store.setSelections({
      // 定制
      propertyName: "", // 楼盘名称
      fuzzyWord: "",
      state: "", // 状态：‘1’-未发布，‘2’-已发布，‘3’-销售中，‘4’-已销售。
      developerId: "",
      developerName: "",
    });
  }

  async exportExcel() {
    let rawData;
    const selections = {
      propertyName: ["like", store.selections.propertyName],
      // fuzzyWord: ["equal", store.selections.fuzzyWord],
      state: ["equal", store.selections.state],
      developerId: ["equal", store.selections.developerId],
    };
    console.log("----- 搜索：", selections);
    const rst = await getRooms({
      where: selections,
      order: store.tableConfig.order || 'desc',
      orderBy: store.tableConfig.orderBy || 'createdate',
      currentPage: 0, // 当前页
      rowsPerPage: 999999, // 每页条数
    });

    if (rst.code === "error") {
      store.openMessageDialogOpen("导出数据查询错误");
      return true;
    } else if (rst.code === "success") {
      rawData = rst.data;
    }

    // 表头
    const xlsxHeader = {
      developerName: "开发商名称",
      propertyName: "楼盘名称",
      buildingNo: "幢号",
      unit: "单元",
      floor: "楼层",
      roomNumber: "房号",
      houseType: "户型",
      buildingArea: "建筑面积(平方米)",
      recordPrice: "备案单价(元/平方米)",
      totalPrice: "备案总价",
      maximumPrice: "最高限价单价",
      totalPrice2: "最高限价总价",
      state: "状态",
      remarks: "备注",
    };

    // 数据内容
    const data = [];
    for (let index = 0; index < rawData.length; index++) {
      const element = rawData[index];
      const newElement = {};
      let developerName = "";
      const developerTable = toJS(store.developerTable);
      for (let index = 0; index < developerTable.length; index++) {
        const element2 = developerTable[index];
        if (element2.ID === element.developerId) {
          developerName = element2.name;
          break;
        }
      }

      newElement.developerName = developerName;
      newElement.propertyName = element.propertyName;
      newElement.buildingNo = element.buildingNo;
      newElement.unit = element.unit;
      newElement.floor = element.floor;
      newElement.roomNumber = element.roomNumber;
      newElement.houseType = element.houseType;
      newElement.buildingArea = element.buildingArea;
      newElement.recordPrice = element.recordPrice;
      newElement.totalPrice = element.totalPrice;
      newElement.maximumPrice = element.maximumPrice;
      newElement.totalPrice2 = element.totalPrice2;
      newElement.state = ["", "未发布", "已发布", "销售中", "已销售"][
        element.state
      ];
      newElement.remarks = element.remarks;
      data.push(newElement);
    }

    // 文件名
    const now = new Date();
    const xlsxName =
      `开发商房源表` +
      `${(Array(4).join(0) + now.getFullYear()).slice(-4)}` +
      `${(Array(2).join(0) + (now.getMonth() + 1)).slice(-2)}` +
      `${(Array(2).join(0) + now.getDate()).slice(-2)}-` +
      `${(Array(2).join(0) + now.getHours()).slice(-2)}` +
      `${(Array(2).join(0) + now.getMinutes()).slice(-2)}` +
      `${(Array(2).join(0) + now.getSeconds()).slice(-2)}-` +
      `${(Array(4).join(0) + Math.round(Math.random() * 9999)).slice(-4)}`;

    const file = exportExcel(data, xlsxHeader, xlsxName);
    return file;
  }

  exportTemplateExcel() {
    const xlsxName = "开发商房源模版";

    const xlsxHeader = {
      developerName: "开发商名称",
      propertyName: "楼盘名称",
      buildingNo: "幢号",
      unit: "单元",
      floor: "楼层",
      roomNumber: "房号",
      houseType: "户型",
      buildingArea: "建筑面积(平方米)",
      recordPrice: "备案单价(元/平方米)",
      totalPrice: "备案总价",
      maximumPrice: "最高限价单价",
      totalPrice2: "最高限价总价",
      remarks: "备注",
    };
    const file = exportExcel([], xlsxHeader, xlsxName);
    return file;
  }

  importExcel(e) {
    console.log(`----- importExcel: `);
    const XLSX = require("xlsx");
    const file = Array.from(e.target.files)[0];
    let reader = new FileReader();
    reader.readAsBinaryString(file);
    const that = this;
    reader.onload = function (event) {
      try {
        let result = event.target.result;
        let xlsxdata = XLSX.read(result, { type: "binary" }); // 读取xlsx
        console.log(`----- xlsxdata: `, xlsxdata);
        for (let n in xlsxdata.Sheets) {
          console.log(`----- xlsxdata.Sheets[${n}]: `, xlsxdata.Sheets[n]);
          let col = XLSX.utils.sheet_to_json(xlsxdata.Sheets[n], {
            header: 1,
            defval: "",
            blankrows: true,
            raw: false,
          }); // 解析为数组
          console.log(col);
          that.doImportExcel(col);
          break; // 只有一页
        }
      } catch (err) {
        store.openMessageDialogOpen("读取Excel失败：", err);
      }
    };
  }

  async doImportExcel(arr) {
    const rst = await addRoomsFromExcel(arr);
    if (rst.code === "error") {
      const checkErrorList = rst.checkErrorList || [];
      let msg = rst.msg || "导入Excel失败";
      msg = `${msg}:`;
      for (let index = 0; index < checkErrorList.length; index++) {
        const element = checkErrorList[index];
        if (index >= 10) {
          msg = `${msg}...`;
          break;
        }
        const errMsg    = element.errMsg;
        const errIndex  = element.index;
        msg = `${msg} 第[${errIndex}]行 ${errMsg};`;
      }
      store.openMessageDialogOpen(msg);
      return true;
    } else if (rst.code === "success") {
      store.openMessageDialogOpen(rst.msg || "导入Excel成功");
      store.search();
      return true;
    }
  }

  render() {
    const { classes } = this.props;
    return (
      <div className={classes.root}>
        <form className={classes.rootform} noValidate autoComplete="off">
          {getIfFuncAuthorized("房票管理-开发商房源管理-添加") && (
            <Button
              color="primary"
              variant="contained"
              aria-label="contained primary button group"
              className={classes.button}
              onClick={(e) => this.setState({ addRoomDialogOpen: true })}
            >
              添加
            </Button>
          )}
          {getIfFuncAuthorized("房票管理-开发商房源管理-删除") && (
            <Button
              color="primary"
              variant="contained"
              aria-label="contained primary button group"
              className={classes.button}
              onClick={this.deleteSelected}
            >
              删除
            </Button>
          )}
          {getIfFuncAuthorized("房票管理-开发商房源管理-发布") && (
            <Button
              color="primary"
              variant="contained"
              aria-label="contained primary button group"
              className={classes.button}
              onClick={this.publishSelectedRoom}
            >
              发布
            </Button>
          )}
          {getIfFuncAuthorized("房票管理-开发商房源管理-撤回") && (
            <Button
              color="primary"
              variant="contained"
              aria-label="contained primary button group"
              className={classes.button}
              onClick={this.recallSelectedRoom}
            >
              撤回
            </Button>
          )}
          {getIfFuncAuthorized("房票管理-开发商房源管理-下载模板") && (
            <Button
              color="primary"
              variant="contained"
              onClick={(e) => this.exportTemplateExcel()}
              className={classes.button}
            >
              下载模板
            </Button>
          )}
          {getIfFuncAuthorized("房票管理-开发商房源管理-导出Excel") && (
            <Button
              color="primary"
              variant="contained"
              onClick={(e) => this.exportExcel()}
              className={classes.button}
            >
              导出Excel
            </Button>
          )}
          {/* {(getIfFuncAuthorized('房票管理-开发商房源管理-Excel导入')) && (
            <Button color="primary" variant="contained"
              name="上传图片"
              onClick={e => this.importExcel(e)}
              id="profileImg"
              type="file"
              className={classes.button}
              onChange={e => this.importExcel(e)}
            >
              Excel导入
            </Button>
          )} */}
          <input
            accept="xlsx/*"
            className={classes.input}
            id="contained-button-file"
            onChange={(e) => this.importExcel(e)}
            type="file"
          />
          {getIfFuncAuthorized("房票管理-开发商房源管理-Excel导入") && (
            <label htmlFor="contained-button-file">
              <Button
                variant="contained"
                color="primary"
                component="span"
                className={classes.button}
              >
                Excel导入
              </Button>
            </label>
          )}
        </form>
        <form className={classes.rootform} noValidate autoComplete="off">
          <FormControl variant="outlined" className={classes.formControl}>
            <InputLabel
              id="demo-simple-select-outlined-label"
              style={{ marginTop: "-8px" }}
            >
              房产商名称
            </InputLabel>
            <Select
              labelId="demo-simple-select-outlined-label"
              id="demo-simple-select-outlined"
              value={store.selections.developerId || ""}
              onChange={(e) => store.onChangeSelection(e, "developerId")}
              label="状态"
              margin="dense"
            >
              <MenuItem value="">
                <em>请选择</em>
              </MenuItem>
              <MenuItem value={""} key={0}>
                {""}
              </MenuItem>
              {store.developerTable.map((row, index) => {
                const ID = row.ID;
                const name = row.name;
                return (
                  <MenuItem value={ID} key={ID}>
                    {name}
                  </MenuItem>
                );
              })}
            </Select>
          </FormControl>
          <TextField
            id="outlined-number"
            label="楼盘名称"
            type="text"
            variant="outlined"
            margin="dense"
            className={classes.textField}
            value={store.selections.propertyName || ""}
            onChange={(e) => store.onChangeSelection(e, "propertyName")}
          />
          <TextField
            id="fuzzy-word"
            label="模糊搜索"
            type="text"
            variant="outlined"
            margin="dense"
            className={classes.textField}
            value={store.selections.fuzzyWord || ""}
            onChange={(e) => store.onChangeSelection(e, "fuzzyWord")}
          />
          <FormControl variant="outlined" className={classes.formControl}>
            <InputLabel
              id="demo-simple-select-outlined-label"
              style={{ marginTop: "-8px" }}
            >
              状态
            </InputLabel>
            <Select
              labelId="demo-simple-select-outlined-label"
              id="demo-simple-select-outlined"
              label="状态"
              value={store.selections.state || ""}
              onChange={(e) => store.onChangeSelection(e, "state")}
              margin="dense"
            >
              <MenuItem value="">
                <em>请选择</em>
              </MenuItem>
              <MenuItem value={"1"}>未发布</MenuItem>
              <MenuItem value={"2"}>已发布</MenuItem>
              <MenuItem value={"3"}>销售中</MenuItem>
              <MenuItem value={"4"}>已销售</MenuItem>
            </Select>
          </FormControl>

          <Button
            color="primary"
            variant="contained"
            aria-label="contained primary button group"
            className={classes.button}
            onClick={this.search}
          >
            搜索
          </Button>
          <Button
            color="primary"
            variant="contained"
            aria-label="contained primary button group"
            className={classes.button}
            onClick={this.clearSelection}
          >
            清除搜索
          </Button>
        </form>

        <Dialog
          aria-labelledby="form-dialog-title"
          open={this.state.addRoomDialogOpen}
          onClose={(e) => this.setState({ addRoomDialogOpen: false, addRoomParams: {} })}
        >
          <DialogTitle id="form-dialog-title" style={{ width: "300px" }}>
            添加房源
          </DialogTitle>
          <DialogContent>
            <FormControl fullWidth>
              <InputLabel
                id="developer-simple-select-outlined-label"
                style={{ marginTop: "-8px" }}
              >
                *房产商名称
              </InputLabel>
              <Select
                labelId="developer-simple-select-outlined-label"
                id="developer"
                value={this.state.addRoomParams.developer || ''}
                onChange={(e) => {
                  this.onRoomDialogChange(e, "developer");
                }}
                label="房产商名称"
                margin="dense"
              >
                <MenuItem value="">
                  <em>请选择</em>
                </MenuItem>
                {store.developerTable.map((row, index) => {
                  const ID = row.ID;
                  const name = row.name;
                  return (
                    <MenuItem value={ID} key={ID}>
                      {name}
                    </MenuItem>
                  );
                })}
              </Select>
            </FormControl>
            <ITextField
              autoFocus
              margin="dense"
              id="buildingName"
              label="*楼盘名称"
              fullWidth

              ivalue={this.state.addRoomParams.buildingName || ''}
              onChange={(e) => this.onRoomDialogChange(e, "buildingName")}
              type=""
              maxLength='10'
              notNull
            />
            <ITextField
              margin="dense"
              id="buildingNo"
              label="*幢号"
              fullWidth

              ivalue={this.state.addRoomParams.buildingNo || ''}
              onChange={(e) => this.onRoomDialogChange(e, "buildingNo")}
              type=""
              maxLength='10'
              notNull
            />
            <ITextField
              margin="dense"
              id="buildingNo2"
              label="*单元"
              fullWidth

              ivalue={this.state.addRoomParams.buildingNo2 || ''}
              onChange={(e) => this.onRoomDialogChange(e, "buildingNo2")}
              type=""
              maxLength='10'
              notNull
            />
            <ITextField
              margin="dense"
              id="floor"
              label="*楼层"
              fullWidth

              ivalue={this.state.addRoomParams.floor || ""}
              onChange={(e) => this.onRoomDialogChange(e, "floor")}
              type=""
              maxLength='10'
              notNull
            />
            <ITextField
              margin="dense"
              id="roomNo"
              label="*房号"
              fullWidth

              ivalue={this.state.addRoomParams.roomNo || ''}
              onChange={(e) => this.onRoomDialogChange(e, "roomNo")}
              type=""
              maxLength='10'
              notNull
            />
            <ITextField
              margin="dense"
              id="layout"
              label="*户型"
              fullWidth

              ivalue={this.state.addRoomParams.layout || ''}
              onChange={(e) => this.onRoomDialogChange(e, "layout")}
              type=""
              maxLength='10'
              notNull
            />
            <ITextField
              margin="dense"
              id="space"
              label="*建筑面积"
              fullWidth

              ivalue={this.state.addRoomParams.space || ''}
              onChange={(e) => this.onRoomDialogChange(e, "space")}
              type="number"
              maxLength='10'
              notNull
            />

            <ITextField
              margin="dense"
              id="pricePerM2"
              label="备案单价(元/平方米)"
              fullWidth

              ivalue={this.state.addRoomParams.pricePerM2 || ''}
              onChange={(e) => this.onRoomDialogChange(e, "pricePerM2")}
              type="number"
              maxLength='10'
              notNull
            />
            <ITextField
              margin="dense"
              id="priceTot"
              label="*备案总价"
              fullWidth

              ivalue={this.state.addRoomParams.priceTot || ''}
              onChange={(e) => this.onRoomDialogChange(e, "priceTot")}
              type="number"
              maxLength='16'
              notNull
            />

            <ITextField
              margin="dense"
              id="minPriceTot"
              label="*最高限价单价"
              fullWidth

              ivalue={this.state.addRoomParams.minPriceTot || ''}
              onChange={(e) => this.onRoomDialogChange(e, "minPriceTot")}
              type="number"
              maxLength='10'
              notNull
            />

            {/* todo */}
            <ITextField
              margin="dense"
              id="	totalPrice2"
              label="*最高限价总价"
              fullWidth

              ivalue={this.state.addRoomParams.totalPrice2 || ''}
              onChange={(e) => this.onRoomDialogChange(e, "totalPrice2")}
              type="number"
              maxLength='16'
              notNull
            />
            <ITextField
              margin="dense"
              id="remarks"
              label="备注"
              fullWidth

              ivalue={this.state.addRoomParams.remarks || ''}
              onChange={(e) => this.onRoomDialogChange(e, "remarks")}
              type=""
              maxLength='20'
            />
          </DialogContent>
          <DialogActions>
            <Button
              color="primary"
              id='addRoom'
              variant="contained"
              aria-label="contained primary button group"
              onClick={this.addRoom}
            >
              确认添加
            </Button>
            <Button
              color="primary"
              id='addRoomDialogOpen'
              variant="contained"
              aria-label="contained primary button group"
              onClick={(e) => this.setState({ addRoomDialogOpen: false, addRoomParams: {} })}
            >
              取消
            </Button>
          </DialogActions>
        </Dialog>
      </div>
    );
  }
}

const SelectionOfRoomManagement = observer(SelectionOfRoomManagementInner);

SelectionOfRoomManagement.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(SelectionOfRoomManagement);
